(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["advent-calendar-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('explorador-advent-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const end = Date.parse(dialog.dataset.end);
  const blog = dialog.dataset.blog === 'true';
  const prefix = 'explorador_advent_2026_';
  const memory = {};
  let lastClosed = 0;
  let previousFocus;
  let timer;
  let expirationTimer;
  let destroyed = false;
  const getSeen = (name) => {
    try { return sessionStorage.getItem(prefix + name) === '1' || memory[name] === true; }
    catch { return memory[name] === true; }
  };
  const setSeen = (name) => {
    memory[name] = true;
    try { sessionStorage.setItem(prefix + name, '1'); } catch {}
  };
  const close = () => { if (dialog.open) dialog.close(); };
  const destroy = () => {
    destroyed = true;
    clearTimeout(timer);
    clearTimeout(expirationTimer);
    close();
    document.removeEventListener('mouseout', onExit);
    document.removeEventListener('visibilitychange', onVisibility);
  };
  const show = (trigger) => {
    if (destroyed || !Number.isFinite(end) || Date.now() >= end) { destroy(); return false; }
    if (dialog.open || document.visibilityState === 'hidden' || Date.now() - lastClosed < 30000) return false;
    if (trigger === 'timed' && getSeen('timed')) return false;
    if (trigger === 'exit' && (!blog || getSeen('exit'))) return false;
    if (document.querySelector('dialog[open], .blog-popup-overlay.active, .promo-popup.active, .menu-drawer[open], cart-drawer.active')) return false;
    previousFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('explorador-advent-popup-open');
    setSeen('timed');
    if (trigger === 'exit') setSeen('exit');
    clearTimeout(timer);
    return true;
  };
  const onExit = (event) => {
    if (event.relatedTarget === null && event.clientY <= 0 && matchMedia('(hover: hover) and (pointer: fine)').matches) show('exit');
  };
  const onVisibility = () => {
    if (Date.now() >= end) { destroy(); return; }
    if (document.visibilityState === 'visible' && !getSeen('timed')) {
      clearTimeout(timer);
      timer = setTimeout(() => show('timed'), 5000);
    }
  };
  const armExpiration = () => {
    const remaining = end - Date.now();
    if (!Number.isFinite(remaining) || remaining <= 0) { destroy(); return; }
    expirationTimer = setTimeout(armExpiration, Math.min(remaining, 86400000));
  };
  dialog.querySelectorAll('[data-advent-close], [data-advent-link]').forEach((element) => element.addEventListener('click', close));
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('explorador-advent-popup-open');
    lastClosed = Date.now();
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });
  if (Date.now() >= end) { destroy(); return; }
  if (!getSeen('timed')) timer = setTimeout(() => show('timed'), 5000);
  if (blog && !getSeen('exit')) document.addEventListener('mouseout', onExit);
  document.addEventListener('visibilitychange', onVisibility);
  armExpiration();
})();
  } catch(e) { console.error(e); }
})();

})();
